module.exports = __webpack_public_path__ + "img/cementos-chihuahua.e281a3cb.png";